/**
 * Tiiliskivi theme JavaScript.
 *
 * This is the main entry point for all theme JavaScript.
 * Import and initialize modules as needed for your project.
 */

/**
 * Available modules (uncomment to enable):
 *
 * // Framework
 * import Vue from '@vue';
 *
 * // Libraries
 * import jQuery from '@jquery';
 * import MoveTo from 'moveto';           // Smooth scrolling
 * import LazyLoad from 'vanilla-lazyload'; // Lazy loading images
 * import reframe from 'reframe.js';       // Responsive iframes
 *
 * // Custom modules
 * import './custom.js';                   // Custom jQuery functionality
 * import './modules/navigation.js';       // Navigation functionality
 * import slick from './modules/slick.min';     // Carousel
 * import fancybox from './modules/jquery.fancybox.min.js'; // Lightbox
 */

// Define JavaScript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');

/**
 * Example: Fit video embeds to container
 * Uncomment if using reframe.js:
 *
 * reframe('.wp-has-aspect-ratio iframe');
 */
